export {CardContact} from './lib/card-contact';